import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import qrImg from "resources/img/puffu/qr.svg";
import { motion, AnimatePresence } from "framer-motion";
import logo from "resources/img/logo.png";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import { useContext, useEffect } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useNavigate } from "react-router-dom";
import TestCameraPage from "./app/TestCameraPage";
import FullScreenCameraPage from "./app/FullScreenCameraPage";
import { AuthContext } from "providers/AuthProvider";

function MobileScan() {
    const { isMobile } = useContext(BrowserDetectContext);
    const { userName } = useContext(AuthContext);
    const navigate = useNavigate();
    const button = {
        rest: { scale: 1 },
        hover: { scale: 1.1 },
        pressed: { scale: 0.95 }
    };
    const onScanClick = () => {

        if (window.BRIDGE && window.BRIDGE.scan) {
            window.BRIDGE.scan();
        } else if (window.webkit.messageHandlers && window.webkit.messageHandlers.BRIDGE) {
            window.webkit.messageHandlers.BRIDGE.postMessage('scan');
        } else {

        }

    }
    return (
        <div style={{ height: "90vh" }}>
            <VerticalFlex>
                <FlexChild>
                    <Center>
                        <img src={logo} />
                    </Center>
                </FlexChild>
                <FlexChild justifyContent={"center"} alignItems={"center"}>
                    <img src={qrImg} width={"80%"} onClick={onScanClick} />


                </FlexChild>
                <FlexChild>

                    <P weight={"bold"} size={isMobile ? "5vw" : 20}>버튼을 눌러 스캔을 시작하세요!</P>
                </FlexChild>
                {/* <FullScreenCameraPage /> */}
                {/* <TestCameraPage /> */}
            </VerticalFlex>
        </div>
    );
}

export default MobileScan;